import React from 'react'
import Serviceimage from './Serviceimage'
import Scroll from '../../pages/Scroll/Scroll'
import Footer from '../../pages/Footer/Footer'
import ServiceText from './ServiceText'
import OurServiceText from './OurServiceText'
import OfferService from './OfferService'
import ServiceCard from './ServiceCard'
import Service from '../../pages/Service/Service'

const OurService = () => {
  return (
    <>
    <Serviceimage/>
    <ServiceText/>
    <OurServiceText/>
    <Service/>
    <ServiceCard/>
    <Scroll/>
    <Footer/>

    
      
    </>
  )
}

export default OurService
